import React from "react";
import "./LogoContainer.css";
import telomeLogo from "../../../../assets/logo/telome-logo-transparent.png"; // adjust path if needed

export default function LogoContainer({ handleNavigate }) {
  return (
    <div
      className="logo-container"
      onClick={() => handleNavigate("create")}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && handleNavigate("create")}
    >
      <img
        src={telomeLogo}
        alt="Telome Logo"
        className="telome-logo"
        draggable="false"
      />
    </div>
  );
}
